<template>
  <div class="content-warp">
    <a-row :gutter="24">
      <a-col :span="10">
        <div class="content-panle bg-white">
          <TableTips 
            :title="$t('personalManaAuthBatch.selectedPersonnelCountTips')"
            :total="persons.length"
          />
          <a-table 
            class="persons-table"
            :columns="personsColumns"
            :pagination="false"
            :dataSource="persons"
            :scroll="persons.length?{ x: 580 }:{}"
          >
            <template slot="operation" slot-scope="text, record">
              <div v-if="record.operation">
                <a 
                  v-for="item in record.operation" 
                  :key="item.type"
                  :disabled="item.disabled"
                  :style="{color: item.color || '#1890ff'}"
                  @click="item.callback(record)"
                >
                  {{$t(item.type)}}
                </a>
              </div>
            </template>
          </a-table>
        </div>
      </a-col>

      <a-col :span="14">
        <div class="content-panle bg-white">
          <TableTips 
            :title="$t('personalManaAuthBatch.devicesTable')"
            :total="pagination.total" 
            :selected="selectedRowKeys.length"
            @clearAllSelected="() => {selectedRowKeys = []}"
          />
          <a-form layout="inline" :form="listSearchForm" @submit.prevent="handleSearchDevices" style="text-align: right;">
            <a-form-item>
              <a-tree-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                style="width: 160px"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                :placeholder="$t('personalManaAuthBatch.searchOrgTxt')"
                :treeData="orgTreeDownSelectionData"
                :treeDefaultExpandedKeys="[orgTreeDownSelectionData[0].value]"
                v-decorator="['deptId', {initialValue: orgTreeDownSelectionData[0].value}]"
              />
            </a-form-item>
            <a-form-item>
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                style="width: 130px"
                :placeholder="$t('personalManaAuthBatch.searchDeviceStatus')"
                :options="searchStatusOptions"
                v-decorator="['searchStatus']"
              />
            </a-form-item>
            <a-form-item>
              <a-input 
                style="width: 130px"
                type="text"
                v-decorator="['searchSNOrName']" 
                :placeholder="$t('personalManaAuthBatch.searchDeviceSNOrName')" >
                <a-icon slot="prefix" type="setting" style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-form-item style="margin-right:0">
              <a-button type="primary" html-type="submit" :loading="loading">
                {{$t('personalManaAuthBatch.searchBtn')}}
              </a-button>
            </a-form-item>
          </a-form>
          <a-table 
            class="devices-table"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: (rowKeys) => {selectedRowKeys = rowKeys} }"
            :columns="devicesColumns" 
            :dataSource="devicesData"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            :scroll="devicesData.length?{ x: 700 }:{}"
          >
            <template slot="status" slot-scope="text, record">
              <a-tag v-if="record.statusCode === 1" color="green">{{text}}</a-tag>
              <a-tag v-else-if="record.statusCode === 2" color="red">{{text}}</a-tag>
              <a-popover v-else  placement="rightBottom">
                <a-tag color="red" style="cursor:pointer">{{text}}</a-tag>
                <template slot="content">
                  <p style="color:rgba(0,0,0,.65);margin:0;max-width:200px;">{{record.errorMessage}}</p>
                </template>
              </a-popover>
            </template>
          </a-table>   
        </div>

        <div style="margin-top: 16px; text-align: right">
          <a-button 
            type="primary" 
            :loading="submitting" 
            :disabled="!selectedRowKeys.length || !persons.length" 
            @click="handleSubmit"
          >{{$t('personalManaAuthBatch.submitBtn')}}</a-button>
          <a-button 
            :style="{ marginLeft: '8px' }" 
            @click="handleBackPersonList"
          >{{$t('personalManaAuthBatch.backListBtn')}}</a-button>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { addAuthorizationBatch } from '@/api/authMana'
import { getDevices } from '@/api/deviceMana';
import TableTips from '@/components/TableTips';

export default {
  name: 'personalManaAuthBatch',
  components: { TableTips },
  data() {
    return {
      personsColumns: this.getPersonsColumns(),
      persons: [],

      listSearchForm: this.$form.createForm(this),
      searchStatusOptions: [],

      searchDeptId: '',
      searchStatus: undefined,
      searchSNOrName: undefined,

      loading: false, // 列表内容是否在加载中
      devicesData: [], // 列表数据源
      devicesColumns: this.getDevicesColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      selectedRowKeys: [], // 列表多选钩中项的Id数组

      submitting: false
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData,
      orgTreeSourceData: state => state.orgStore.orgTreeSourceData
    }),
    ...mapGetters(['orgTreeDownSelectionData'])
  },
  watch: {
    lang: function (lang) {
      this.personsColumns = this.getPersonsColumns()
      this.devicesColumns = this.getDevicesColumns()
    }
  },  
  beforeCreate() {
    if (!this.$route.query.ps) {
      this.$error({
        title: this.$t('personalManaAuthBatch.pageErrTitle'),
        content: this.$t('personalManaAuthBatch.pageErrContent'),
        okText: this.$t('personalManaAuthBatch.backBtn'),
        onOk: () => {
          this.$multiTab.closeCurrentPage();
          this.$router.push({ name: 'personalManaIndex' });
        }
      });
    };
  },
  created() {
    this.onlineStateMap = {};
    this.enumsData.onlineState.forEach(item => {
      this.onlineStateMap[item.value] = item.title;
    })

    this.searchStatusOptions = [].concat([{ title: this.$t('personalManaAuthBatch.searchDeviceStatusAllOption'), value: '', key: 'all' }], this.enumsData.onlineState);
        
    this.getDevicesListData()
  },
  activated() {
    if (this.$route.query.ps) {
      this.oldPersonSources = JSON.parse(this.$route.query.ps)
      this.persons = this.oldPersonSources.map(item => {
        return {
          key: item.id,
          id: item.id,
          name: item.name,
          idNumber: item.idNumber,
          deptFullName: item.deptFullName,
          operation: [{
            type: 'personalManaAuthBatch.listPersonRemoveBtn',
            disabled: false,
            color: '#f5222d',
            callback: this.handleDeletePerson
          }]
        }
      });
    }
  },
  
  methods: {
    getPersonsColumns() {
      return [
        {
          title: this.$t('personalManaAuthBatch.listPersonName'),
          dataIndex: 'name',
          width: '20%'
        },
        {
          title: this.$t('personalManaAuthBatch.listPersonIDNumber'),
          dataIndex: 'idNumber',
          width: '30%'
        },
        {
          title: this.$t('personalManaAuthBatch.listPersonOrg'),
          dataIndex: 'deptFullName',
          width: '35%'
        },
        {
          title: this.$t('personalManaAuthBatch.listPersonOperation'),
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    getDevicesColumns() {
      return [
        {
          title: this.$t('personalManaAuthBatch.listDeviceSN'),
          dataIndex: 'SN',
          width: '25%'
        },
        {
          title: this.$t('personalManaAuthBatch.listDeviceName'),
          dataIndex: 'name',
          width: '20%'
        },
        {
          title: this.$t('personalManaAuthBatch.listDeviceStatus'),
          dataIndex: 'status',
          width: '15%',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('personalManaAuthBatch.listDeviceOrg'),
          dataIndex: 'deptFullName'
        }
      ]
    },

    // 移除人员
    handleDeletePerson(person) {
      let vm = this;
      this.oldPersonSources = this.oldPersonSources.filter(item => {
        return item.id !== person.id
      })
      this.$route.query.ps = JSON.stringify(this.oldPersonSources)

      this.persons = this.persons.filter(item => {
        return item.id !== person.id
      })
      if (this.persons.length === 0) {
        this.handleBackPersonList()
      }
    },
    // 搜索设备列表
    handleSearchDevices() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.searchDeptId = values.deptId;
          this.searchStatus = values.searchStatus;
          this.searchSNOrName = values.searchSNOrName;

          this.pagination.current = 1;
          this.getDevicesListData('search');
        }
      });
    },
    // 获取设备列表数据
    async getDevicesListData(triggerType) {
      try {
        this.loading = true;
        const res = await getDevices({
          deptId: this.searchDeptId || this.orgTreeDownSelectionData[0].value,
          deviceTypes: [101],
          perPage: this.pagination.pageSize,
          page: this.pagination.current,
          keyword: this.searchSNOrName && this.searchSNOrName.trim(),
          onlineState: this.searchStatus
        })
        this.loading = false;

        this.devicesData = this.createDeviceTableData(res.data.collection);
        if (triggerType === 'search') this.selectedRowKeys = [];        
        this.pagination.total = res.data.size;
      } catch (error) {
        this.loading = false;
      }
    },
    createDeviceTableData(data) {
      return data.map(item => {
        return {
          key: item.id,
          id: item.id,
          SN: item.deviceSn,
          name: item.deviceName,
          status: this.onlineStateMap[item.deviceOnlineState],
          statusCode: item.deviceOnlineState,
          errorMessage: item.errorMessage, 
          doorState: item.doorState,
          version: item.softVer,
          personCount: item.authCount,
          deptFullName: item.deptFullName,
          deptid: item.deptId
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.getDevicesListData();
    },

    // 提交授权
    async handleSubmit() {
      try {
        this.submitting = true
        await addAuthorizationBatch({
          deviceIds: this.selectedRowKeys,
          personIds: this.persons.map(item => item.id)
        })
        this.submitting = false
        
        this.$notification.success({
          message: this.$t('personalManaAuthBatch.authorizeSuccess'),
          duration: 2
        })
        setTimeout(() => {
          this.handleBackPersonList()
        }, 2000)
      } catch (error) {
        this.submitting = false
      }
    },    

    // 返回人员列表
    handleBackPersonList() {
      this.$multiTab.closeCurrentPage();
      this.$router.push({ name: 'personalManaIndex' });
    }
  }

}
</script>

<style scoped>
.panle-table-title{
  margin: 0;
  padding: 5px 16px;
  font-size: 16px;
}
.panle-table-title:before{
  content: "";
  margin-right: 10px;
  border: 2px solid #1890ff;
  border-radius: 5px;
}
.persons-table{
  min-height: 598px;
}
.devices-table{
  min-height: 558px;
}
</style>